import { apiGet } from '@/store/api';
import type { GatResponseResult } from '@/types/GatResponseResult';
import type { ProformaListItem } from '@/types/ProformaTypes';

export interface PortcallProformaRequestResponse {
  proformas: ProformaListItem[];
  // currencies: ProformaCurrency[];
}

/** This function retrieves portcall proformas based on the provided portcall ID.  */
export async function getPortcallProformas(
  portcallId: string
): Promise<GatResponseResult<PortcallProformaRequestResponse>> {
  const response = (await apiGet(
    `proforma/portcall/${portcallId}`
  )) as unknown as GatResponseResult<PortcallProformaRequestResponse>;
  return response;
}
